module.exports = __webpack_public_path__ + "img/brown_etal_nonlinear_equation_vn.a16824fe.png";